import React from 'react'
import TextField from '@mui/material/TextField';


const Input = (props) => {
    return (
        <TextField
            id={props.id}
            label={props.label}
            variant="outlined"
            size="small"
            value={props.value}
            onChange={props.onChange && props.onChange}
            disabled={props.disabled}
            placeholder={props.placeholder}
            error={props.error}
            helperText={props.helperText}
            slotProps={{
                input: {
                    sx: {
                        padding: '8px 10px',
                        fontSize: '14px',
                    },
                },
            }}
            sx={{
                '& .MuiInputLabel-root': {
                    fontSize: '14px',
                },
                '& .MuiOutlinedInput-root': {
                    padding: 0,
                },
            }}
        />
    )
}

export default Input